import React from 'react'

import { isNullable } from '@app/utils'

import type { QuotaTitleProps } from './types'

export const QuotaTitle: React.FC<QuotaTitleProps> = ({ quotas }) => {
  if (isNullable(quotas)) return null

  const { brandCount, brandQuota, eppCount, eppQuota } = quotas

  return (
    <span>
      Квота Бренд: { brandCount } из { brandQuota }, Квота EPP/ЧТМ: { eppCount } из { eppQuota }
    </span>
  )
}
